export const useTasks = () => {
    const createTask = async (
        taskData: {
            description: string;
            dueDate: string;
            assignedTo?: string;
            attachments: JSON;
        },
        contactId: string | undefined,
        businessId: string | undefined
    ) => {
        try {
            const response = await $fetch('/api/v1/tasks', {
                method: 'POST',
                body: { taskData, contactId, businessId },
            });
            return { data: response, error: null };
        } catch (error) {
            console.error('Error creating task:', error);
            return { data: null, error };
        }
    };

    const updateTask = async (
        taskId: string | undefined,
        taskData: {
            description: string;
            dueDate: string;
            assignedTo: string;
        },
        contactId: string | undefined,
        businessId: string | undefined
    ) => {
        try {
            const response = await $fetch(`/api/v1/tasks/${taskId}`, {
                method: 'PUT',
                body: { taskId, taskData, contactId, businessId },
            });
            return { data: response, error: null };
        } catch (error) {
            console.error(`Error updating task with id ${taskId}`, error);
            return { data: null, error };
        }
    };

    const updateTaskAttachments = async (
        taskId: string | undefined,
        updatedAttachments: object
    ) => {
        try {
            const response = await $fetch(`/api/v1/tasks/${taskId}/attachments`, {
                method: 'PUT',
                body: { taskId, updatedAttachments },
            });
            return response;
        } catch (error) {
            console.error(`Error updating task with id ${taskId}:`, error);
            return response.error;
        }
    };

    const updateTaskStatus = async (
        taskId: string | undefined,
        isCompleted: boolean
    ) => {
        try {
            const response = await $fetch(`/api/v1/tasks/status/${taskId}`, {
                method: 'PUT',
                body: { taskId, isCompleted },
            });
            return { data: response, error: null };
        } catch (error) {
            console.error(`Error updating task with id ${taskId}:`, error);
            return { data: null, error };
        }
    };

     const deleteTask = async (taskId: string) => {
        try {
            const response = await $fetch(`/api/v1/tasks/${taskId}/archive`, {
                method: 'PUT',
            });
            return { data: response, error: null };
        } catch (error) {
            console.error(`Error archiving task with id ${taskId}:`, error);
            return { data: null, error };
        }
    };

    const getAllTasks = async () => {
        const res = await $fetch(`/api/v1/tasks`, {
            method: 'GET',
        });
        return res;
    };

    const getAllTasksByUser = async () => {
        const res = await $fetch(`/api/v1/tasks/user`, {
            method: 'GET',
        });
        return res;
    };

    const getTaskById = async (taskId: string) => {
        const res = await $fetch(`/api/v1/tasks/${taskId}`, {
            method: 'GET',
        });
        return res;
    };

    const getAllTasksByContactId = async (contactId: string) => {
        const res = await $fetch(`/api/v1/tasks/contact/${contactId}`, {
            method: 'GET',
        });
        return res;
    };

    const getAllTasksByBusinessId = async (businessId: string) => {
        const res = await $fetch(`/api/v1/tasks/business/${businessId}`, {
            method: 'GET',
        });
        return res;
    };

    const getAllTasksByContactIdAndBusinessId = async (
        contactId: string,
        businessId: string
    ) => {
        const res = await $fetch(
            `/api/v1/tasks/contact/${contactId}/business/${businessId}`,
            {
                method: 'GET',
            }
        );
        return res;
    };

    return {
        createTask,
        updateTask,
        updateTaskAttachments,
        updateTaskStatus,
        deleteTask,
        getAllTasks,
        getAllTasksByUser,
        getTaskById,
        getAllTasksByContactId,
        getAllTasksByBusinessId,
        getAllTasksByContactIdAndBusinessId,
    };
};
